module.exports = __webpack_public_path__ + "img/china.b4a241ab.png";